<div class="header">
  <span class="font-medium-title-large flex-1-0-0">{{ filterTitle }}</span>
  <button class="circle-medium" (click)="onClose()">
    <i class="fa-regular fa-times circle-icon"></i>
  </button>
</div>
<div class="flex-r padding-16 flex-1-0-0">
  <div class="content">
    @for (filter of filters; track $index) {
      <!-- Date Range Input -->
      @if (filter.type === 'daterange') {
        <div class="input-simple align-self-stretch">
          <label class="input-label" for="startDate"> Von </label>
          <p-datepicker
            (click)="stopPropagation($event)"
            inputId="startDate"
            name="startDate"
            class="align-self-stretch"
            [(ngModel)]="filter.value.startDate"
            dateFormat="dd.mm.yy"
            placeholder="TT.MM.JJJJ" />
        </div>
        <div class="input-simple align-self-stretch">
          <label class="input-label" for="endDate"> Bis </label>
          <p-datepicker
            (click)="stopPropagation($event)"
            inputId="endDate"
            name="endDate"
            class="align-self-stretch"
            [(ngModel)]="filter.value.endDate"
            dateFormat="dd.mm.yy"
            placeholder="TT.MM.JJJJ" />
        </div>
        <p-divider class="form-divider"></p-divider>
      } @else if (filter.type === 'date') {
        <div class="input-simple align-self-stretch">
          <label class="input-label" for="date"> {{ filter.label }} </label>
          <p-datepicker
            (click)="stopPropagation($event)"
            inputId="date"
            name="date"
            class="align-self-stretch"
            [(ngModel)]="filter.value"
            dateFormat="dd.mm.yy"
            placeholder="TT.MM.JJJJ" />
        </div>
        <p-divider class="form-divider"></p-divider>
      } @else if (filter.type === 'seminar') {
        <div class="flex-c gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <label class="input-label" for="select"> {{ filter.label }} </label>
            <p-multiSelect
              id="select"
              [showHeader]="true"
              class="align-self-stretch"
              styleClass="filter-seminar-select"
              panelStyleClass="filter-seminar-select-panel"
              [(ngModel)]="filter.value"
              [options]="filter.selectOptions"
              optionLabel="title"
              optionValue="id"
              [filter]="true"
              filterBy="title"
              filterPlaceHolder="Seminar suchen..."
              selectedItemsLabel="{0} ausgewählt"
              [placeholder]="filter.placeholder"
              [loading]="filter.selectOptionsLoading"
              loadingIcon="fa-regular fa-spinner-third fa-spin">
              <ng-template let-seminar pTemplate="item">
                <div class="seminar-option">
                  <div>{{ seminar.title }}</div>
                  @if (seminar.dates && seminar.dates.length > 0) {
                    <span class="font-regular-body-medium text-secondary">
                      {{ getSeminarDateString(seminar) }}
                    </span>
                  }
                  @if (seminar.isDraft) {
                    <span class="is-draft-tag"> Entwurf</span>
                  }
                </div>
              </ng-template></p-multiSelect
            >
          </div>

          @if (filter.value) {
            <div class="flex-r flex-wrap gap-16">
              @for (value of filter.value; track $index) {
                <div [class]="getStatusChip(value).class" class="seminar-chip">
                  {{ getSeminarTitle(value) }}
                  <button
                    type="button"
                    class="remove-status-button"
                    (click)="removeStatusFromFilter($event, value, filter)">
                    <i class="fa-regular fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
        <p-divider class="form-divider"></p-divider>
      } @else if (filter.type === 'select') {
        <div class="input-simple align-self-stretch">
          <label class="input-label" for="select"> {{ filter.label }} </label>
          <p-select
            id="select"
            class="align-self-stretch"
            [(ngModel)]="filter.value"
            [options]="filter.selectOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="filter.placeholder"
            [loading]="filter.selectOptionsLoading"
            loadingIcon="fa-regular fa-spinner-third fa-spin" />
        </div>

        <p-divider class="form-divider"></p-divider>
      } @else if (filter.type === 'multiselect') {
        <div class="flex-c gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <label class="input-label" for="select"> {{ filter.label }} </label>
            <p-multiSelect
              id="select"
              [showHeader]="false"
              class="align-self-stretch"
              [(ngModel)]="filter.value"
              [options]="filter.selectOptions"
              optionLabel="label"
              optionValue="value"
              selectedItemsLabel="{0} ausgewählt"
              [placeholder]="filter.placeholder"
              [loading]="filter.selectOptionsLoading"
              loadingIcon="fa-regular fa-spinner-third fa-spin" />
          </div>
          @if (filter.value) {
            <div class="flex-r flex-wrap gap-16">
              @for (value of filter.value; track $index) {
                <div [class]="getStatusChip(value).class" class="chip">
                  {{ getStatusChip(value, filter.selectOptions).text }}
                  <button
                    type="button"
                    class="remove-status-button"
                    (click)="removeStatusFromFilter($event, value, filter)">
                    <i class="fa-regular fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
        <p-divider class="form-divider"></p-divider>
      } @else if (filter.type === 'checkbox') {
        <div class="input-simple align-self-stretch">
          <label class="flex-r gap-8 align-center" for="checkbox">
            <div class="inwi-checkbox">
              <input id="checkbox" type="checkbox" [(ngModel)]="filter.value" />
            </div>
            {{ filter.label }}
          </label>
        </div>
        <p-divider class="form-divider"></p-divider>
      } @else {
        <input [(ngModel)]="filter.value" placeholder="Enter value" />
      }
    }
    <button
      class="inwi-icon-text-button-medium-outline"
      (click)="resetFilters()">
      <div class="button-content">
        <i class="button-icon fa-regular fa-arrow-rotate-left"></i>
        <div class="button-text">Zurücksetzen</div>
      </div>
    </button>
  </div>
</div>
<div class="footer">
  <button class="inwi-text-button-medium-outline" (click)="onClose(true)">
    <div class="button-content">
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button class="inwi-text-button-medium-primary" (click)="applyFilters()">
    <div class="button-content">
      <div class="button-text">Anwenden</div>
    </div>
  </button>
</div>
